// ------------------------------------
// Constants
// ------------------------------------

export const UPDATE_TIME = 'UPDATE_TIME'
export const HIDE_SECONDARY = 'HIDE_SECONDARY'
export const REMOVE_TIME = 'REMOVE_TIME'

// ------------------------------------
// Actions
// ------------------------------------

export function updateTime(payload) {
  return {
    type: UPDATE_TIME,
    payload
  }
}

export function hideSecondary() {
  return {
    type: HIDE_SECONDARY
  }
}

export function removeTime() {
  return {
    type: REMOVE_TIME
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  src: null,
  currentTime: null,
  isPlaying: false,
  showSecondary: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case UPDATE_TIME: {
      const { id, src, currentTime, isPlaying, showSecondary } = action.payload
      return {
        id,
        src,
        currentTime,
        isPlaying,
        showSecondary
      }
    }
    case HIDE_SECONDARY: {
      return {
        ...state,
        showSecondary: false
      }
    }
    case REMOVE_TIME: {
      return initialState
    }
  }
  return state
}
